import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { DuplicateBorrowers, DuplicateBorrowerFields } from 'app/models/dto/duplicate-borrowers.model';
import { DuplicateBorrowerService } from 'app/services/duplicate-borrower/duplicate-borrower.service';
import { ClearDuplicateBorrowers, GetDuplicateBorrowers } from './duplicate-borrowers.actions';
import { catchError, map, of } from 'rxjs';

export class DuplicateBorrowersStateModel {
    duplicateBorrowers: DuplicateBorrowers | null;
    loading: boolean;
}

@State<DuplicateBorrowersStateModel>({
    name: 'duplicateBorrowers',
    defaults: {
        duplicateBorrowers: null,
        loading: true
    }
})

@Injectable()
export class DuplicateBorrowersState {
    
    @Selector()
    static duplicateBorrowers(state: DuplicateBorrowersStateModel) {
        return state.duplicateBorrowers;
    }
    
    @Selector()
    static loadingDuplicateBorrowers(state: DuplicateBorrowersStateModel) {
        return state.loading;
    }

    constructor(
        private duplicateBorrowerService: DuplicateBorrowerService
    ) {}

    @Action(GetDuplicateBorrowers)
    getBorrowerStatuses(
      { patchState }: StateContext<DuplicateBorrowersStateModel>,
      { borrowerId }: GetDuplicateBorrowers
    ) {
        patchState({ loading: true });
        return this.duplicateBorrowerService.getDuplicateBorrowers(borrowerId).pipe(
            catchError(() => {
                patchState({ loading: false });
                return of();
            }),
            map((duplicateBorrowers: DuplicateBorrowers) => {
                duplicateBorrowers.fields = this.responseFields(duplicateBorrowers.fields);
                duplicateBorrowers.values = duplicateBorrowers.values || {};
                patchState({ duplicateBorrowers, loading: false });
            })
        );
    }

    @Action(ClearDuplicateBorrowers)
    clearDuplicateBorrowers({patchState}: StateContext<DuplicateBorrowersStateModel>) {
        patchState({ duplicateBorrowers: null });
    }
    
    private responseFields(fields): DuplicateBorrowerFields {
        return Object.keys(fields)
        .reduce((acc, key) => {
            const field = fields[key];
            acc[key] = field instanceof Array ? field : Object.values(field);
            return acc;
        }, {}) as DuplicateBorrowerFields;
    }
}
